import { Component, computed, inject, input } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { isString } from 'lodash';
import { OnyxTooltipDirective } from '../../../directives/onyx-tooltip.directive';
import { OverflowHelper } from '../../../helpers/overflow.helper';
import { I18N_NAMESPACE } from '../../../internal/constants';
import { OnyxIconComponent } from '../../icons/onyx-icon/onyx-icon.component';
import { OnyxLinkComponent } from '../../links/onyx-link/onyx-link.component';
import type { OnyxTooltipContext } from '../../tooltip/interfaces';
import type { OnyxLabelLink } from '../interfaces';

@Component({
  selector: 'onyx-input-label',
  imports: [
    OnyxIconComponent,
    OnyxTooltipDirective,
    TranslatePipe,
    OnyxLinkComponent,
    TranslatePipe,
  ],
  templateUrl: './onyx-input-label.component.html',
  styleUrl: './onyx-input-label.component.scss',
})
export class OnyxInputLabelComponent {
  protected readonly overflowHelper = inject(OverflowHelper);
  private readonly translateService = inject(TranslateService);

  public readonly variant = input<'label' | 'title'>('label');
  public readonly label = input.required<string>();
  public readonly required = input(false);
  public readonly disabled = input(false);
  public readonly hint = input<OnyxTooltipContext>();
  public readonly link = input<OnyxLabelLink | null>(null);
  public readonly alignRight = input(false);

  protected readonly I18N = `${I18N_NAMESPACE}.inputLabel`;

  protected translatedHint = computed<OnyxTooltipContext>(() => {
    const hint = this.hint();
    return isString(hint) && hint ? this.translateService.instant(hint) : hint;
  });
}
